import { Routes } from '@angular/router';

import { permissionGuard } from '@core/auth/permission.guard';

import { DashboardComponent } from '@features/dashboard/dashboard.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [permissionGuard],
    data: { permission: 'Dashboard:View' }
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [permissionGuard],
    data: { permission: 'Dashboard:View' }
  },
  {
    path: 'products',
    loadChildren: () => import('@features/products/products.routes').then(m => m.PRODUCTS_ROUTES)
  },
  {
    path: 'posting-profiles',
    loadChildren: () =>
      import('@features/posting-profiles/posting-profiles.routes').then(m => m.POSTING_PROFILES_ROUTES)
  },
  {
    path: 'marketplaces',
    loadChildren: () => import('@features/marketplaces/marketplaces.routes').then(m => m.MARKETPLACES_ROUTES)
  },
  {
    path: 'listings',
    loadChildren: () => import('@features/listings/listings.routes').then(m => m.LISTINGS_ROUTES)
  },
  {
    path: 'customers',
    loadChildren: () => import('@features/customers/customers.routes').then(m => m.CUSTOMERS_ROUTES)
  },

  { path: '**', redirectTo: 'dashboard' }
];
